import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FilesContainer } from 'modules/files';
import { parseCloudFiles } from 'modules/files';
import { useObjectCard } from '../context/ObjectCardProvider';

const ObjectTabFiles = () => {
    const { t } = useTranslation(['Objects', 'FileNavigator', 'common']);
    const { objectId, vObject, setVObject, isEditLocked } = useObjectCard();

    const files = useMemo(
        () => parseCloudFiles(vObject?.object?.objectFiles),
        [vObject?.object?.objectFiles],
    );
    const canEdit = !isEditLocked;

    const handleFilesChange = async (nextFiles) => {
        setVObject((prev) => {
            if (!prev) return prev;
            return {
                ...prev,
                object: {
                    ...(prev.object || {}),
                    objectFiles: nextFiles,
                },
            };
        });
        return true;
    };

    return (
        <div className="px-3 pb-3">
            <FilesContainer
                files={files}
                scope={{ objectId: Number(objectId || 0) }}
                imageColProps={{ xs: 6, md: 4, lg: 3 }}
                canEdit={canEdit}
                addButtonLabel={t('btnAddFiles')}
                uploadingLabel={t('common:buttons.uploading')}
                saveFirstMessage={t('messSaveObjectFirst')}
                errorMessage={t('common:messError')}
                uploadSuccessMessage={t('FileNavigator:messDownloadSuccess')}
                onFilesChange={handleFilesChange}
            />
        </div>
    );
};

export default ObjectTabFiles;
